import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Story from './views/Story.vue'
import RSVP from './views/RSVP.vue'
import store from './store'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/photos',
      name: 'photos',
      component: () => import(/* webpackChunkName: "photos" */ './views/Photos.vue')
    },
    {
      path: '/story',
      name: 'story',
      component: Story
    },
    {
      path: '/accommodations',
      name: 'accommodations',
      redirect: '/'
    },
    {
      path: '/registry',
      name: 'registry',
      redirect: '/'
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: RSVP
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "photos" */ './views/Admin.vue'),
      meta: {
        authRequired: true
      }
    },
    {
      path: '/auth/sign-in',
      name: 'sign-in',
      component: () => import(/* webpackChunkName: "signIn" */ './views/SignIn.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: {
        authRequired: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (store.state.user) {
      // console.log('user')
      next()
    } else {
      // console.log('no user')
      // console.log(to)
      let fullPath = to.fullPath
      // next('/auth')
      let userWatcher = store.watch(
        (state) => state.user,
        (value) => {
          // console.log('user watch')
          // console.log(value)
          if (value) {
            next(fullPath)
          } else {
            next('/auth/sign-in?redirect=' + fullPath)
          }
          // unwatch
          userWatcher()
        }
      )
    }
  } else {
    next()
  }
})

export default router
